import {Communication} from "@app/relation/shared/communication";

export class QuotationRelation {
  id: number;
  uuid: string;
  number: number;
  title: string;
  firstName: string;
  infix: string;
  familyName: string;
  companyName: string;
  address: string;
  zip: string;
  city: string;
  telephone: string;
  communications: Communication[];
  hasQuotationEmailAddress: boolean;
  source: string;
}
